import { UnderwritingSubmissionDetailPageSlug } from '@converge/data';
import { Stack } from '@mui/material';
import { useUnderwritingSubmissionDetailPage } from '../underwriting.submission.detail.hooks';
import { UnderwritingSubmissionPageContainer } from '../underwriting.submission.page.container';
import { ConvergeButton } from '../../../presentation';

export const UnderwritingSubjectivitiesPage = () => {
  const { navigate } = useUnderwritingSubmissionDetailPage();

  return (
    <UnderwritingSubmissionPageContainer
      title="Subjectivities"
      onNext={() => {
        navigate.page({
          sectionUrl: UnderwritingSubmissionDetailPageSlug.Bind,
        });
      }}
      footerLeft={
        <Stack gap={2} flexDirection={'row'}>
          <ConvergeButton label="Bind" onClick={() => {}} />
        </Stack>
      }
      onPrevious={() => {
        navigate.page({
          sectionUrl: UnderwritingSubmissionDetailPageSlug.Quote,
        });
      }}
    ></UnderwritingSubmissionPageContainer>
  );
};

export default UnderwritingSubjectivitiesPage;
